<div class="yf-row center gap-4">
  <ion-icon name="flash-outline" color="light" class="medium-icon"></ion-icon>
  <ion-text color="warning" [class]="$textClass()">{{$energy() | energy}} <span [class]="$umClass()">kWh</span></ion-text>
</div>